module.exports = __webpack_public_path__ + "img/CT.Bridges.Superstructure.Prestressed_Concrete_Box_Girder_Bridge_30m.Reinforced_Concrete.7c7f1893.png";